import {SidebarSponsors as SponsorsComponent} from '@github-ui/code-view-sidebar/components/SidebarSponsors'
import {isCombinedSidebarPayloadEnabled} from '@github-ui/code-view-sidebar/is-enabled'
import {useCombinedSidebarPayload} from '@github-ui/code-view-sidebar/use-combined-sidebar-payload'
import {useSponsorDataSuspense} from '@github-ui/repo-sponsor-button/hooks/use-sponsor-data'

interface Props {
  ownerLogin: string
  repoName: string
  isOrgOwned?: boolean
}

export function SidebarSponsors(props: Props) {
  return isCombinedSidebarPayloadEnabled() ? (
    <SidebarSponsorsCombined {...props} />
  ) : (
    <SidebarSponsorsIndividual {...props} />
  )
}

function SidebarSponsorsCombined({ownerLogin, repoName}: Props) {
  const {sponsors} = useCombinedSidebarPayload(ownerLogin, repoName)
  if (!sponsors) return null
  return <SponsorsComponent {...sponsors} />
}

function SidebarSponsorsIndividual({ownerLogin, repoName, isOrgOwned}: Props) {
  const {data} = useSponsorDataSuspense({ownerLogin, repoName, isOrgOwned})

  if (!data) return null
  return <SponsorsComponent {...data} />
}
